<template>
  <div v-if="unsupported" class="video-unsupported">
    <Unsupported />
  </div>
  <video crossorigin="anonymous" ref="player" v-else autoplay controls :src="linkVideo" type="video/x-matroska" class="video-js video-player" @playing="onPlaying" @pause="$emit('pause')" @timeupdate="handleTimeUpdate" @waiting="onVideoWaiting" @stalled="onVideoStalled" @error="onVideoError">
    <source :src="linkVideo" type="video/x-matroska" />
    <track
      v-for="(track, index) in textTrack"
      :key="index"
      :src="track.src"
      :label="track.label"
      :kind="track.kind"
      :srclang="track.srclang"
      :default="track.default || false"
    />
    <embed id="divxplayer" type="video/divx" width="1024" height="768" :src="linkVideo" autoPlay="true" pluginspage="http://go.divx.com/plugin/download/" />
  </video>
</template>

<script>
import 'video.js/dist/video-js.css';
import Unsupported from '@/views/Player/Unsupported';
import { getAudioTest } from '@/helpers/utils';

export default {
  name: 'PlayerMkv',
  components: {
    Unsupported,
  },
  props: {
    linkVideo: {
      type: String,
    },
    textTrack: {
      type: Array,
    },
    startTime: {
      type: Number,
      default: 0,
    },
  },
  emits: ['timeupdate'],
  data() {
    return {
      player: null,
      unsupported: false,
    };
  },
  watch: {
    linkVideo() {
      this.setStartTime();
    },
    startTime() {
      this.setStartTime();
    },
  },
  mounted() {
    const player = this.$refs.player;

    player.addEventListener('error', () => {
      this.unsupported = true;
    });

    player.addEventListener('loadedmetadata', () => {
      if (this.startTime >= 0) {
        player.currentTime = this.startTime;
      }
    });

    this.setStartTime();
  },
  methods: {
    async setStartTime() {
      const player = this.$refs.player;
      const audioIsWorking = await getAudioTest(player);

      if (player) {
        player.currentTime = this.startTime;
      }

      if (!audioIsWorking) {
        console.error('audio is not working');
      }
    },
    handleTimeUpdate(event) {
      const video = event.target;
      const currentSec = Math.floor(video.currentTime);

      if (!isNaN(currentSec)) {
        this.$emit('timeupdate', currentSec);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.video-unsupported {
  background-color: $black50;
  padding-top: 100px;
  z-index: 20;
  position: relative;
  top: 0;
  height: 100vh;
}
.video-player {
  background-color: $black;
  width: 100%;
  height: 100vh;
  &__select {
    display: flex;
    position: absolute;
    top: 20px;
    z-index: 100;
    left: 20px;
    &-episode {
      width: 100px !important;
      border-radius: 2px;
      margin-left: 10px;
    }
    &-season {
      width: 100px !important;
      border-radius: 2px;
    }
  }
}
</style>
